import React from 'react';
import { Label } from 'reactstrap';

function CustomLabel({ ...rest }) {
  return <Label {...rest} />;
}

export default CustomLabel;
